import type { ValueGetterParams } from 'ag-grid-community';
import type { UserType } from '../../types/user';

/**
 * emailからフィルタ用の文字列を生成する。
 * contextにusersが存在する必要がある。
 * 解決できなかった場合はemail返す。
 * @param params [ValueGetterParams]
 * @returns string
 */
const updatedByFilterValueGetter = (params: ValueGetterParams) => {
  const userEmail: string = params.getValue('updatedBy');
  const users: UserType[] | undefined = params.context?.users;
  const name: string | undefined = users?.find((user) => user.email === userEmail)?.username;
  const filterValue: string = name ?? userEmail;
  return filterValue;
};

export default updatedByFilterValueGetter;
